import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import organizationsReducer from './slices/organizationsSlice';
import categoryReducer from './slices/categorySlice';
import organizationStatsReducer from './slices/organizationStatsSlice';
import appContextReducer from './slices/appContextSlice';
import { localStorageMiddleware, safeLocalStorageGet } from './middleware/localStorageMiddleware';

// Load initial state from localStorage with error handling
const loadInitialState = () => {
  try {
    const storedDynamicSegment = safeLocalStorageGet('orgadmin_dynamic_segment');
    return {
      organizations: {
        data: [],
        loading: false,
        error: null,
        sessionExpired: false,
        fetched: false,
        dynamicSegment: storedDynamicSegment || '',
      },
    };
  } catch (error) {
    console.error('Failed to load initial state from localStorage:', error);
    // Return default state if localStorage fails
    return {
      organizations: {
        data: [],
        loading: false,
        error: null,
        sessionExpired: false,
        fetched: false,
        dynamicSegment: '',
      },
    };
  }
};

export const store = configureStore({
  reducer: {
    organizations: organizationsReducer,
    categories: categoryReducer,
    organizationStats: organizationStatsReducer,
    appContext: appContextReducer,
  },
  preloadedState: loadInitialState(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch<AppDispatch>();
